import React from 'react';
import { Box, Typography } from '@mui/material';

const GiftHero = ({heroImage, heroTitle, heroDescription}) => {
  return (
    <Box sx={{backgroundImage:`url(${heroImage})`, backgroundRepeat:'no-repeat', backgroundSize:'cover',  height: {md: '476px', xs: '350px'},objectFit: 'fill',  display:'flex', alignItems:'flex-end', borderRadius:'35px',marginTop:4}}>
        <Box sx={{backgroundColor:'rgba(89, 57, 77, 0.7)', borderRadius:'0 0 30px 30px', p:2, width:'100%', height:'170px'}}>
            <Typography variant='h2' component='h2' sx={{color:'#F6A704', mb:1, fontSize:{xs: '1.5rem', md:'3rem'}}}>
                {heroTitle}
            </Typography>
            <Typography sx={{color:'#FBFAFF', fontSize:{xs: '1rem', md:'1.25rem'}}}>
                {heroDescription}
            </Typography>
        </Box>
    </Box>
  )
}

export default GiftHero